import './index.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter, RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { Layout } from '@beehive/components';
import Sider from './Sider';
import Header, { getSecondaryMenus } from './Header';
import { AccountState, MenuType, MenuRouteType } from 'modules/types/account';
import { ProjectDetailDrawer, ProjectDetailSingle } from '../SmWorkbench/ProjectDetail';
import { ProjectDetailDrawer as LsProjectDetailDrawer } from '../LsWorkbench/ProjectDetail';
import { ProjectDetailDrawer as NewProjectDetailDrawer } from '../OutWorkbench/ProjectDetail';
import OutWorkbenchList from '../OutWorkbench/index';
import {
  ProjectDetailDrawer as BiddingProjectDetailDrawer,
  ProjectDetailSingle as BiddingProjectDetailSingle,
} from '../OutBidding/ProjectDetail';
import { getCurrentPathName, getLocationPaths, makeRoutes, getDefaultMenuKey } from 'utils';
import NotFound from '../404';
import _ from 'lodash';
import classnames from 'classnames';
import NewAnnouncementGlobalList from 'containers/OutBidding/components/NewAnnouncementModal/GlobalList';
import { localPx2rem } from '@mpc/common/src/utils';
import { Dispatch, bindActionCreators } from 'redux';
import * as menuCountActions from 'modules/actions/menuCount';
import * as actions from 'modules/actions/account';
import MPCLayout from './MPCLayout';
import RouteRegister from './RouteRegister';
import { getVendorStorage, getSolarToken } from '@mpc/common/src/utils';
import SpinGlobal from '@bedrock/components/lib/Spin/Global';
import IntegrityModalGate from '@mpc/common/src/components/IntegrityModal';

interface MainProps extends RouteComponentProps {
  account: AccountState;
}
interface MainState {
  id?: number;
  collapsed: boolean;
  unCollapsedByMouseMove: boolean;
  selectedMenu: string;
  menuRoutes: MenuRouteType[];
}

const LEFT_SIDER_WIDTH = {
  width: 208,
  collapsedWidth: 88,
};

class Main extends Component<MainProps, MainState> {
  public static getDerivedStateFromProps(nextProps: MainProps, prevState: MainState) {
    const {
      account: { id, menus },
    } = nextProps;
    const currentPathname = getCurrentPathName(getLocationPaths(nextProps.location.pathname));
    if (currentPathname !== prevState.selectedMenu) {
      return {
        selectedMenu: currentPathname,
      };
    } else if (id !== prevState.id) {
      return {
        id,
        menuRoutes: makeRoutes(menus),
      };
    }
    return null;
  }

  constructor(props: MainProps) {
    super(props);
    const {
      account: { menus },
      location: { pathname },
    } = props;
    const paths = getLocationPaths(pathname);
    this.state = {
      collapsed: false,
      unCollapsedByMouseMove: false,
      menuRoutes: makeRoutes(menus),
      selectedMenu: getCurrentPathName(paths) || getDefaultMenuKey(menus),
    };
  }

  public componentDidMount() {
    this.handleWindowResize = _.debounce(this.handleWindowResize, 100);
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  private handleWindowResize = () => {
    if (window.innerWidth < 1450 && !this.state.collapsed) {
      this.onCollapse(true, false);
    } else if (window.innerWidth >= 1450 && this.state.collapsed) {
      this.onCollapse(false, false);
    }
  };

  public onCollapse = (collapsed: boolean, unCollapsedByMouseMove: boolean) => {
    this.setState({ collapsed, unCollapsedByMouseMove });
  };

  public handleClick = (e: any) => {
    if (this.state.selectedMenu !== e.key) {
      this.setState({
        selectedMenu: e.key,
      });
    }
  };

  public getHeaderMenus = (selectedMenu: string) => {
    if (selectedMenu.includes('/projectDetailSingle')) {
      return [
        {
          default: true,
          key: 'projectDetailSingle',
          name: '任务单详情',
        },
      ];
    }

    if (selectedMenu.includes('outWorkbenchPortal')) {
      return [
        {
          default: true,
          key: 'projectDetailSingle',
          name: '',
        },
      ];
    }

    const {
      account: { menus },
    } = this.props;
    const targetMenus = menus;
    const targetKey = selectedMenu.split('/')[0];
    const headerMenus = _.find(targetMenus, (menu: MenuType) => menu.key === targetKey);
    return headerMenus && headerMenus.children ? headerMenus.children : [];
  };

  public render() {
    const {
      account: { menus, permissions, currentUser },
      location: { search, pathname },
      location,
      history,
    } = this.props;
    const { collapsed, unCollapsedByMouseMove, selectedMenu, menuRoutes } = this.state;
    const leftSideWidth =
      collapsed || unCollapsedByMouseMove ? LEFT_SIDER_WIDTH.collapsedWidth : LEFT_SIDER_WIDTH.width;
    // 顶部一级菜单
    const headerMenus = this.getHeaderMenus(selectedMenu);
    const paths = getLocationPaths(pathname);
    // 顶部二级菜单
    const selectedPrimaryMenu = paths[1] || getDefaultMenuKey(headerMenus);
    const secondaryMenus = getSecondaryMenus(headerMenus, selectedPrimaryMenu);
    const secondayDefaultMenu = paths[2] || getDefaultMenuKey(secondaryMenus);
    const layoutContentClasses = classnames('mpc-layout-content', {
      'mpc-layout-content-with-secondary-menus': secondaryMenus.length,
    });

    // 判断是否动态返回 bidding 菜单
    const haveOutBidding =
      Array.isArray(menus) && menus.find((v: any) => v.key === 'outBidding');


    if (!currentUser) {
      return <SpinGlobal />;
    }

    console.log('menuRoutes', menuRoutes);

    return (
      <>
        <MPCLayout {...this.props}>
          <RouteRegister {...this.props} menuRoutes={menuRoutes} queryMenuCount={() => {}} />
        </MPCLayout>
        {!!haveOutBidding && <NewAnnouncementGlobalList />}
        {currentUser?.mail && <IntegrityModalGate mail={currentUser.mail} />}
      </>
    );
  }
}

const mapState2Props = (state: any, ownProps: any) => {
  const { menuCount, account } = state;
  let { menus, vendorProcessAudit } = account;
  const { vendorId } = getVendorStorage();
  // 旧供应商不显示公司管理菜单
  if (vendorId?.indexOf('NEV') === -1) {
    menus = menus.filter((v: any) => v.key !== 'outCompanyManagement');
  }
  if (vendorProcessAudit?.onboarded === false) {
    menus = [
      {
        default: false,
        key: 'outCompanyManagement',
        name: '公司管理',
        children: [
          {
            default: false,
            key: 'outCompanyInfo',
            name: '公司信息',
          },
        ],
      },
    ];
  }

  return {
    account: { ...state.account, menus },
    ...menuCount,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<menuCountActions.GetMenuCountSuccess>) => {
  return bindActionCreators(
    {
      getMenuCount: menuCountActions.getMenuCount,
    },
    dispatch,
  );
};

export default withRouter(connect(mapState2Props, mapDispatchToProps)(Main));
